let allSelectedOptionsGlobalCopy;

export function evaluateLinkvisibilityConditions(
  allSelectedOptions,
  conditions
) {
  allSelectedOptionsGlobalCopy = allSelectedOptions;
  if (!conditions) {
    return areAllDropdownsSelected(allSelectedOptionsGlobalCopy);
  }

  let response = true;

  if (!conditions.onSelected && !conditions.allSelected) {
    for (let i = 0; i < conditions.length; i++) {
      let currentCondition = [conditions[i]];
      response = response && evaluateComplexCondition(currentCondition);
    }
    response =
      response && areAllDropdownsSelected(allSelectedOptionsGlobalCopy);
  } else {
    if (conditions.onSelected) {
      for (let i = 0; i < conditions.onSelected.length; i++) {
        let currentCondition = [conditions.onSelected[i]];
        response = response && evaluateComplexCondition(currentCondition);
      }
      if (response) {
        return response;
      }
    }

    if (conditions.allSelected) {
      response = true;
      for (let i = 0; i < conditions.allSelected.length; i++) {
        let currentCondition = [conditions.allSelected[i]];
        response = response && evaluateComplexCondition(currentCondition);
      }
    } else {
      return areAllDropdownsSelected(allSelectedOptionsGlobalCopy);
    }

    response =
      response && areAllDropdownsSelected(allSelectedOptionsGlobalCopy);
  }

  return response;
}

function areAllDropdownsSelected(state) {
  for (let i = 0; i < state.length; i++) {
    if (state[i].valueId === "") {
      return false;
    }
  }
  return true;
}

export function matchConditions(conditions, selectedDropdowns) {
  let matched = false;
  for (let i = 0; i < conditions.length; i++) {
    let con = conditions[i];
    if (matched) {
      break;
    }
    for (let i2 = 0; i2 < selectedDropdowns.length; i2++) {
      let sd = selectedDropdowns[i2];
      let id = `${sd.id}.${sd.valueId}`;
      if (con === id) {
        matched = true;
        break;
      }
    }
  }
  return matched;
}

export function calculateStateValues(
  valueData,
  allSelectedOptions,
  currentSelectedOption
) {
  const dropdownData = valueData;
  allSelectedOptionsGlobalCopy = allSelectedOptions;
  let approvedOptions = [];

  for (let i = 0; i < dropdownData.values.length; i++) {
    let currentValue = dropdownData.values[i];
    if (currentValue.conditions === undefined) {
      dropdownData.disabled = !currentValue.visible;
      dropdownData.show = true;
      approvedOptions.push(currentValue);
    } else {
      for (let j = 0; j < currentValue.conditions.length; j++) {
        let condition = [currentValue.conditions[j]];
        if (evaluateComplexCondition(condition)) {
          dropdownData.disabled = !currentValue.visible;
          dropdownData.show = true;
          approvedOptions.push(currentValue);
          break;
        }
      }
    }
  }
  if (approvedOptions.length === 1) {
    dropdownData.disabled = true;
    currentSelectedOption = {
      valueId: approvedOptions[0].id,
      nummer: approvedOptions[0].nummer,
      id: dropdownData.id
    };
  } else if (approvedOptions.length === 0) {
    dropdownData.disabled = true;
    dropdownData.show = false;
    currentSelectedOption = {
      valueId: dropdownData.default.id,
      nummer: dropdownData.default.nummer,
      id: dropdownData.id
    };
  }
  return {
    ...dropdownData,
    values: approvedOptions,
    selected: currentSelectedOption
  };
}

function evaluateComplexCondition(condition) {
  let finalVerdictBoolean = false;
  for (let i = 0; i < condition.length; i++) {
    let currentCondition = condition[i];

    if (!Array.isArray(currentCondition) || currentCondition.length === 1) {
      finalVerdictBoolean =
        finalVerdictBoolean || evaluateUnaryCondition(currentCondition);
      if (finalVerdictBoolean === true) {
        return finalVerdictBoolean;
      }
    } else if (currentCondition.length === 3) {
      finalVerdictBoolean =
        finalVerdictBoolean || evaluateBinaryCondition(currentCondition);
      if (finalVerdictBoolean === true) {
        return finalVerdictBoolean;
      }
    }
  }
  return finalVerdictBoolean;
}

function evaluateUnaryCondition(currentCondition) {
  let unaryExpression;
  let negation = false;
  let response = false;
  if (Array.isArray(currentCondition)) {
    unaryExpression = currentCondition[0];
  } else {
    unaryExpression = currentCondition;
  }

  if (typeof unaryExpression === "boolean") {
    return unaryExpression;
  }

  if (unaryExpression.substring(0, 1) === "!") {
    negation = true;
    unaryExpression = unaryExpression.slice(1);
  }

  for (let i = 0; i < allSelectedOptionsGlobalCopy.length; i++) {
    let currentState = allSelectedOptionsGlobalCopy[i];

    if (
      currentState !== undefined &&
      ((unaryExpression.includes(currentState.id) &&
        unaryExpression === `${currentState.id}.${currentState.valueId}`) ||
        (unaryExpression.includes(currentState.id) &&
          unaryExpression === `${currentState.id}.*`))
    ) {
      response = true;
      response = negation ? !response : response;
      return response;
    }
  }
  response = negation ? !response : response;
  return response;
}

function evaluateBinaryCondition(currentCondition) {
  let left = currentCondition[0];
  let right = currentCondition[2];
  if (left.length !== 1) {
    left = evaluateBinaryCondition(left);
  }
  if (right.length !== 1) {
    right = evaluateBinaryCondition(right);
  }
  if (currentCondition[1] === "&&") {
    return evaluateUnaryCondition(left) && evaluateUnaryCondition(right);
  } else if (currentCondition[1] === "||") {
    return evaluateUnaryCondition(left) || evaluateUnaryCondition(right);
  }
}



// WEBPACK FOOTER //
// ./src/js/StateValueCalculations.js